import { ReactComponent as Add } from '../../assets/icons/add.svg';
import { ReactComponent as Add2 } from '../../assets/icons/add2.svg';
import { ReactComponent as Revert } from '../../assets/icons/revert.svg';
import { ReactComponent as Search } from '../../assets/icons/search.svg';
import { ReactComponent as ArrowDown } from '../../assets/icons/arrow_down_select.svg';
import { ReactComponent as Flag } from '../../assets/icons/flag.svg';
import { ReactComponent as Global } from '../../assets/icons/global.svg';
import { ReactComponent as Config } from '../../assets/icons/settings.svg';
import { ReactComponent as Application } from '../../assets/icons/application.svg';
import { ReactComponent as Logout } from '../../assets/icons/logout.svg';
import { ReactComponent as SortArrows } from '../../assets/icons/sort-arrows.svg';
import { ReactComponent as SortArrowUp } from '../../assets/icons/arrow-up.svg';
import { ReactComponent as SortArrowDown } from '../../assets/icons/arrow-down.svg';
import { ReactComponent as Delete } from '../../assets/icons/delete.svg';
import { ReactComponent as Edit } from '../../assets/icons/edit.svg';
import { ReactComponent as CheckboxChecked } from '../../assets/icons/checkbox_checked.svg';
import { ReactComponent as CheckboxUnchecked } from '../../assets/icons/checkbox_unchecked.svg';
import { ReactComponent as LeftArrow } from '../../assets/icons/left-arrow.svg';
import { ReactComponent as RightArrow } from '../../assets/icons/right-arrow.svg';
import { ReactComponent as RadioButton } from '../../assets/icons/radio_button_unselected.svg';
import { ReactComponent as RadioButtonSelected } from '../../assets/icons/radio_button_selected.svg';
import { ReactComponent as Selected } from '../../assets/icons/selected.svg';
import { ReactComponent as Data } from '../../assets/icons/data.svg';
import { ReactComponent as Import } from '../../assets/icons/import.svg';
import { ReactComponent as Task } from '../../assets/icons/task.svg';
import { ReactComponent as Drag } from '../../assets/icons/drag.svg';
import { ReactComponent as NoColor } from '../../assets/icons/no-color.svg';
import { ReactComponent as Gear } from '../../assets/icons/gear.svg';
import { ReactComponent as Export } from '../../assets/icons/export.svg';
import { ReactComponent as Poll } from '../../assets/icons/poll.svg';
import { ReactComponent as PollDisabled } from '../../assets/icons/poll_disabled.svg';
import { ReactComponent as Calendar } from '../../assets/icons/calendar.svg';
import { ReactComponent as Pen } from '../../assets/icons/pen.svg';
import { ReactComponent as Cloud } from '../../assets/icons/cloud.svg';
import { ReactComponent as Link } from '../../assets/icons/link.svg';
import { ReactComponent as Union } from '../../assets/icons/union.svg';
import { ReactComponent as Design } from '../../assets/icons/design.svg';
import { ReactComponent as Publish } from '../../assets/icons/publish.svg';
import { ReactComponent as Visible } from '../../assets/icons/visible.svg';
import { ReactComponent as Hidden } from '../../assets/icons/hidden.svg';
import { ReactComponent as Folder } from '../../assets/icons/folder.svg';
import { ReactComponent as FolderCloud } from '../../assets/icons/folder-cloud.svg';
import { ReactComponent as FolderLinked } from '../../assets/icons/folder-linked.svg';
import { ReactComponent as Layer } from '../../assets/icons/layer-1.svg';
import { ReactComponent as LayerCloud } from '../../assets/icons/layer-2.svg';
import { ReactComponent as VirtualLayer } from '../../assets/icons/virtual-layer-1.svg';
import { ReactComponent as VirtualLayerCloud } from '../../assets/icons/virtual-layer-2.svg';
import { ReactComponent as Inspect } from '../../assets/icons/inspect.svg';
import { ReactComponent as Error } from '../../assets/icons/error.svg';
import { ReactComponent as Close } from '../../assets/icons/close.svg';
import { ReactComponent as SyncArrowUp } from '../../assets/icons/sync-arrow-up.svg';

export type SvgProps = {
  fill?: string;
  stroke?: string;
  className?: string;
  width?: string;
};

export const Icons = {
  Add: (props: SvgProps): JSX.Element => <Add fill="currentColor" {...props} />,
  Add2: (props: SvgProps): JSX.Element => <Add2 fill="currentColor" {...props} />,
  Revert: (props: SvgProps): JSX.Element => <Revert {...props} />,
  Search: (props: SvgProps): JSX.Element => <Search {...props} />,
  ArrowDown: (props: SvgProps): JSX.Element => <ArrowDown fill="currentColor" {...props} />,
  ArrowUp: (props: SvgProps): JSX.Element => (
    <ArrowDown fill="currentColor" {...props} style={{ transform: 'rotate(180deg)' }} />
  ),
  Flag: (props: SvgProps): JSX.Element => <Flag fill="currentColor" {...props} />,
  Global: (props: SvgProps): JSX.Element => <Global fill="currentColor" {...props} />,
  Config: (props: SvgProps): JSX.Element => <Config fill="currentColor" {...props} />,
  Application: (props: SvgProps): JSX.Element => <Application fill="currentColor" {...props} />,
  Logout: (props: SvgProps): JSX.Element => <Logout fill="currentColor" {...props} />,
  SortArrows: (props: SvgProps): JSX.Element => <SortArrows fill="currentColor" {...props} />,
  SortArrowUp: (props: SvgProps): JSX.Element => <SortArrowUp fill="currentColor" {...props} />,
  SortArrowDown: (props: SvgProps): JSX.Element => <SortArrowDown fill="currentColor" {...props} />,
  Delete: (props: SvgProps): JSX.Element => <Delete fill="currentColor" {...props} />,
  Edit: (props: SvgProps): JSX.Element => <Edit fill="currentColor" {...props} />,
  CheckboxChecked: (props: SvgProps): JSX.Element => <CheckboxChecked {...props} />,
  CheckboxUnchecked: (props: SvgProps): JSX.Element => <CheckboxUnchecked {...props} />,
  LeftArrow: (props: SvgProps): JSX.Element => <LeftArrow fill="currentColor" {...props} />,
  RightArrow: (props: SvgProps): JSX.Element => <RightArrow fill="currentColor" {...props} />,
  RadioButton: (props: SvgProps): JSX.Element => <RadioButton {...props} />,
  RadioButtonSelected: (props: SvgProps): JSX.Element => <RadioButtonSelected {...props} />,
  Selected: (props: SvgProps): JSX.Element => <Selected {...props} />,
  Data: (props: SvgProps): JSX.Element => <Data {...props} />,
  Import: (props: SvgProps): JSX.Element => <Import {...props} />,
  Task: (props: SvgProps): JSX.Element => <Task {...props} />,
  Drag: (props: SvgProps): JSX.Element => <Drag {...props} />,
  NoColor: (props: SvgProps): JSX.Element => <NoColor {...props} />,
  Gear: (props: SvgProps): JSX.Element => <Gear {...props} />,
  Export: (props: SvgProps): JSX.Element => <Export {...props} />,
  Poll: (props: SvgProps): JSX.Element => <Poll {...props} />,
  PollDisabled: (props: SvgProps): JSX.Element => <PollDisabled {...props} />,
  Pen: (props: SvgProps): JSX.Element => <Pen {...props} />,
  Calendar: (props: SvgProps): JSX.Element => <Calendar {...props} />,
  Cloud: (props: SvgProps): JSX.Element => <Cloud {...props} />,
  Link: (props: SvgProps): JSX.Element => <Link {...props} />,
  Union: (props: SvgProps): JSX.Element => <Union {...props} />,
  Design: (props: SvgProps): JSX.Element => <Design {...props} />,
  Publish: (props: SvgProps): JSX.Element => <Publish {...props} />,
  Visible: (props: SvgProps): JSX.Element => <Visible {...props} />,
  Hidden: (props: SvgProps): JSX.Element => <Hidden {...props} />,
  Layer: (props: SvgProps): JSX.Element => <Layer {...props} />,
  Folder: (props: SvgProps): JSX.Element => <Folder {...props} />,
  FolderLinked: (props: SvgProps): JSX.Element => <FolderLinked {...props} />,
  FolderCloud: (props: SvgProps): JSX.Element => <FolderCloud {...props} />,
  LayerCloud: (props: SvgProps): JSX.Element => <LayerCloud {...props} />,
  VirtualLayer: (props: SvgProps): JSX.Element => <VirtualLayer {...props} />,
  VirtualLayerCloud: (props: SvgProps): JSX.Element => <VirtualLayerCloud {...props} />,
  Inspect: (props: SvgProps): JSX.Element => <Inspect {...props} />,
  Error: (props: SvgProps): JSX.Element => <Error {...props} />,
  SyncArrowUp: (props: SvgProps): JSX.Element => <SyncArrowUp {...props} />,
  Close: (props: SvgProps): JSX.Element => <Close {...props} />,
};
